import { DataCache, SharedKeyRelationship } from 'lib/DataCache';

import { BerthAssignmentDetailsResponse } from 'data/models/BerthAssignmentDetailsResponse';

import { PCCache, PCCollection } from 'data/PCCache';

export class BerthAssignmentDetailsCache extends DataCache {
    BerthAssignmentDetailsResponses = PCCollection(BerthAssignmentDetailsResponse);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship(this.BerthAssignmentDetailsResponses, data.BerthReservations, r => r.BerthReservation, null);
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/berthassignmentdetails/cache.ts